document.addEventListener('click', (e) => {
  const link = e.target.closest('.js-video-link');
  if (!link || !link.getAttribute('href')) {
    return;
  }
  e.preventDefault();
  const newWin = window.open(link.href, '_blank');
  if (!newWin) {
    window.location.href = link.href;
  }
});
